module.exports = __webpack_public_path__ + "static/media/banner3.79a6ef03.jpg";